export enum MarketplacePartnerAffiliationType {
  None = 0,
  AGS = 1,
  GemAndJewel = 2,
}
